import { createYupSchema, ICustomField, RideFormFields } from "@ryde/shared";

type BulkUpdateFormFields = "rideTypeId" | "metadata.remarks";

export const bulkUpdateFormValidationRules: Record<
  BulkUpdateFormFields,
  ICustomField
> = {
  rideTypeId: {
    name: RideFormFields.rideTypeId,
    isColumn: true,
    formValidation: {
      type: "number",
      rules: [
        {
          validation: "min",
          params: [1],
        },
      ],
    },
  },
  "metadata.remarks": {
    name: "metadata.remarks",
    isColumn: true,
    formValidation: {
      type: "string",
      rules: [],
    },
  },
};
export const bulkUpdateFormValidationSchema = createYupSchema(
  Object.values(bulkUpdateFormValidationRules),
);
